module.exports = __webpack_public_path__ + "static/media/4 rose realistic surreal ink thorn realism tattoo sleeve black and grey.1280x1706.a09580ed.webp";